export default "__VITE_ASSET__Coh_Ct6f__"